import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";

import { BasicCustomCursor } from "@goodgamestudios/core";
import { AvatarVO } from "../../gamevo/AvatarVO";
import { Poker2Model } from "../../model/Poker2Model";

import Container = createjs.Container;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;
import Point = createjs.Point;
import Rectangle = createjs.Rectangle;

/**
 * avatar-icon with zoom
 */
export class AvatarHolder extends Container {

    public static AVATAR_ZOOM_MAX: number = 2; // 200%
    public static AVATAR_ZOOM_SPEED: number = 6; // bigger is slow
    public static AVATAR_MOVE_SPEED: number = .95; // small is slow
    public static AVATAR_ZOOM_TOLERANCE: number = .01; // calculations are never exactly

    private zoomBegin: number = NaN;
    private zoomEnd: number = NaN;
    private moveXY: Point;

    private avatar: Container;
    private avatarRectBegin: Rectangle;
    private avatarMitte: Point;
    private enableZoom: boolean;

    constructor(avatarVO: AvatarVO, enableZoom: boolean = true) {
        super();
        this.avatar = AvatarHelper.drawAvatarByItemArray(Poker2Model.avatarData.getAvatarClothesArray(avatarVO));
        if (this.avatar) {
            this.addEventListener(Event.ADDED_TO_STAGE, this.bindFunction(this.eventInitAvatarZoom));
            this.addChild(this.avatar);
        }
        this.enableZoom = enableZoom;
    }

    //
    // zoom
    //

    /**
     * zoom the avatar-icon's of cards
     */
    private eventInitAvatarZoom(event: Event): void {
        this.removeEventListener(Event.ADDED_TO_STAGE, this.bindFunction(this.eventInitAvatarZoom));
        //
        this.zoomEnd = this.zoomBegin = this.avatar.scaleX;
        this.avatarRectBegin = this.getRect(null);
        this.avatarMitte = new Point(this.avatarRectBegin.left + this.avatarRectBegin.width / 2, this.avatarRectBegin.top + this.avatarRectBegin.height / 2);
        this.moveXY = new Point();
        //
        this.addEventListener(Event.REMOVED_FROM_STAGE, this.bindFunction(this.destroyAvatarZoom));
        //
        this.addEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.eventMouseDownAvatarZoom));
        this.addEventListener(MouseEvent.MOUSE_DOWN, this.bindFunction(this.eventMouseDownAvatarZoom));
        this.addEventListener(MouseEvent.MOUSE_UP, this.bindFunction(this.eventMouseUpAvatarZoom));
        this.addEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.eventMouseUpAvatarZoom));
        this.addEventListener(MouseEvent.PRESS_MOVE, this.bindFunction(this.eventMouseMoveAvatarZoom));
    }

    private destroyAvatarZoom(event: Event): void {
        this.removeEventListener(Event.REMOVED_FROM_STAGE, this.bindFunction(this.destroyAvatarZoom));
        //
        this.removeEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.eventMouseDownAvatarZoom));
        this.removeEventListener(MouseEvent.MOUSE_DOWN, this.bindFunction(this.eventMouseDownAvatarZoom));
        this.removeEventListener(MouseEvent.MOUSE_UP, this.bindFunction(this.eventMouseUpAvatarZoom));
        this.removeEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.eventMouseUpAvatarZoom));
        this.removeEventListener(MouseEvent.PRESS_MOVE, this.bindFunction(this.eventMouseMoveAvatarZoom));
        //
        this.removeEventListener(Event.ENTER_FRAME, this.bindFunction(this.eventLoopAvatarZoom));
    }

    /**
     * begin zoom out to AVATAR_ZOOM_MAX
     */
    private eventMouseDownAvatarZoom(event: MouseEvent): void {
        if (!this.enableZoom) {
            return;
        }
        Poker2LayoutManager.getInstance().customCursor.setCursorType(BasicCustomCursor.CURSOR_ZOOM);
        if (event.type == "mousedown") {
            this.zoomEnd = 2;
            this.moveXY = new Point(this.avatarMitte.x - event.localX, this.avatarMitte.y - event.localY);
            this.addEventListener(Event.ENTER_FRAME, this.bindFunction(this.eventLoopAvatarZoom));
        }
    }

    /**
     * begin zoom in to zoomBegin
     */
    private eventMouseUpAvatarZoom(event: MouseEvent): void {
        if (!this.enableZoom) {
            return;
        }
        Poker2LayoutManager.getInstance().customCursor.setCursorType(BasicCustomCursor.CURSOR_ZOOM);
        this.zoomEnd = this.zoomBegin;
        this.moveXY = new Point();
    }

    /**
     * move the center of zoom
     */
    private eventMouseMoveAvatarZoom(event: MouseEvent): void {
        this.moveXY = new Point(this.avatarMitte.x - event.localX, this.avatarMitte.y - event.localY);
    }

    /**
     * zoom to zoomTarget
     */
    private eventLoopAvatarZoom(event: Event): void {
        var dx: number = NaN;
        var dy: number = NaN;
        var ax: number = NaN;
        var ay: number = NaN;
        var zoom: number = (this.avatar.scaleX * (6 - 1) + this.zoomEnd) / 6;
        //
        if (zoom - 1 < 0.01) {
            this.moveXY.x *= 0.95;
            this.moveXY.y *= 0.95;
            if (Math.abs(this.moveXY.x) + Math.abs(this.moveXY.y) < 0.01) {
                // zoom end
                zoom = 1;
                this.moveXY = new Point();
                this.removeEventListener(Event.ENTER_FRAME, this.bindFunction(this.eventLoopAvatarZoom));

            }
        }
        this.avatar.scaleX = this.avatar.scaleY = zoom;

        ax = (this.avatar.width - this.avatarRectBegin.width) / 2;
        ay = (this.avatar.height - this.avatarRectBegin.height) / 2;

        this.avatar.x = Math.max(-Math.abs(ax), Math.min(Math.abs(ax), this.moveXY.x)) - ax;
        this.avatar.y = Math.max(-Math.abs(ay), Math.min(Math.abs(ay), this.moveXY.y)) - ay;
    }
}
import { Poker2LayoutManager } from "../Poker2LayoutManager";
import { AvatarHelper } from "./AvatarHelper";
classImplementsInterfaces(AvatarHolder, "Container");
